module.exports = __webpack_public_path__ + "img/3.076d9d07.jpg";